import axios from 'axios';
import { appUrl, smlUrl } from '../../../../../utils/config';
import { DELETE_INVITE, DESTROY_BACKDROP, FETCH_TEAM_ASSOCIATES, OPEN_BACKDROP } from '../types';
import { FETCH_TEAM_ASSOCIATES_LOADING } from '../types';
import { applyMiddleware } from 'redux';

export const fetchTeamAssociates = (data) => (dispatch) => {
    // Construct the API URL dynamically

    // const teamMembersList = {
    //   status: true,
    //   data: [
    //     {
    //       saas_user_id: 1,
    //       profile_pic: "https://example.com/profile1.jpg",
    //       full_name: "Tanvi Shukla",
    //       email_address: "tanvi.shukla@hcgel.com",
    //       email_change_to: null,
    //       phone_number: "+91 9475948494",
    //       country: "India",
    //       employee_number: 419556,
    //       department_id: "D001",
    //       department_name: "External Manufacturing - Service Manager",
    //       collaborator_role_id: "R001",
    //       roleName: "Full access",
    //       access: "full",
    //       invitation_status: "Accepted",
    //       associatedCDMOOrgIDs: "all",
    //       associated_cdmo_list: [
    //         {
    //           cdmo_name: "CDMO India",
    //           cdmo_id: 101
    //         }
    //       ],
    //       two_step_auth_id: "enabled",
    //       edit_phone_number: true,
    //       azure_AD_signin: true
    //     },
    //     {
    //       saas_user_id: 2,
    //       profile_pic: "https://example.com/profile2.jpg",
    //       full_name: "Santhi Cherukuri",
    //       email_address: "santhi.cherukuri@hcgel.com",
    //       email_change_to: null,
    //       phone_number: "+91 9574985055",
    //       country: "India",
    //       employee_number: 339293,
    //       department_id: "D002",
    //       department_name: "Quality Assurance - Head",
    //       collaborator_role_id: "R002",
    //       roleName: "Partial access",
    //       access: "partial",
    //       invitation_status: "Pending",
    //       associatedCDMOOrgIDs: "2,3",
    //       associated_cdmo_list: [
    //         {
    //           cdmo_name: "CDMO Global",
    //           cdmo_id: 102
    //         },
    //         {
    //           cdmo_name: "CDMO Europe",
    //           cdmo_id: 103
    //         }
    //       ],
    //       two_step_auth_id: "disabled",
    //       edit_phone_number: false,
    //       azure_AD_signin: false
    //     },
    //     {
    //       saas_user_id: 3,
    //       profile_pic: "https://example.com/profile3.jpg",
    //       full_name: "Rohit Verma",
    //       email_address: "rohit.verma@hcgel.com",
    //       email_change_to: null,
    //       phone_number: "+91 9845093845",
    //       country: "India",
    //       employee_number: 528476,
    //       department_id: "D003",
    //       department_name: "Manufacturing - Supervisor",
    //       collaborator_role_id: "R003",
    //       roleName: "Full access",
    //       access: "full",
    //       invitation_status: "Accepted",
    //       associatedCDMOOrgIDs: "all",
    //       associated_cdmo_list: [
    //         {
    //           cdmo_name: "CDMO Asia",
    //           cdmo_id: 104
    //         }
    //       ],
    //       two_step_auth_id: "enabled",
    //       edit_phone_number: true,
    //       azure_AD_signin: true
    //     },
    //     {
    //       saas_user_id: 4,
    //       profile_pic: "https://example.com/profile4.jpg",
    //       full_name: "Meera Iyer",
    //       email_address: "meera.iyer@hcgel.com",
    //       email_change_to: null,
    //       phone_number: "+91 8765092834",
    //       country: "India",
    //       employee_number: 678901,
    //       department_id: "D004",
    //       department_name: "Regulatory Affairs - Analyst",
    //       collaborator_role_id: "R004",
    //       roleName: "Partial access",
    //       access: "partial",
    //       invitation_status: "Rejected",
    //       associatedCDMOOrgIDs: "2",
    //       associated_cdmo_list: [
    //         {
    //           cdmo_name: "CDMO US",
    //           cdmo_id: 105
    //         }
    //       ],
    //       two_step_auth_id: "disabled",
    //       edit_phone_number: false,
    //       azure_AD_signin: false
    //     },
    //     {
    //       saas_user_id: 5,
    //       profile_pic: "https://example.com/profile5.jpg",
    //       full_name: "Anil Kumar",
    //       email_address: "anil.kumar@hcgel.com",
    //       email_change_to: null,
    //       phone_number: "+91 9902837465",
    //       country: "India",
    //       employee_number: 112233,
    //       department_id: "D005",
    //       department_name: "Logistics - Coordinator",
    //       collaborator_role_id: "R005",
    //       roleName: "Full access",
    //       access: "full",
    //       invitation_status: "Accepted",
    //       associatedCDMOOrgIDs: "3",
    //       associated_cdmo_list: [
    //         {
    //           cdmo_name: "CDMO Australia",
    //           cdmo_id: 106
    //         }
    //       ],
    //       two_step_auth_id: "enabled",
    //       edit_phone_number: true,
    //       azure_AD_signin: true
    //     },
    //     {
    //       saas_user_id: 6,
    //       profile_pic: "https://example.com/profile6.jpg",
    //       full_name: "Priya Menon",
    //       email_address: "priya.menon@hcgel.com",
    //       email_change_to: null,
    //       phone_number: "+91 7894561230",
    //       country: "India",
    //       employee_number: 445566,
    //       department_id: "D006",
    //       department_name: "Procurement - Manager",
    //       collaborator_role_id: "R006",
    //       roleName: "Partial access",
    //       access: "partial",
    //       invitation_status: "Pending",
    //       associatedCDMOOrgIDs: "all",
    //       associated_cdmo_list: [
    //         {
    //           cdmo_name: "CDMO Germany",
    //           cdmo_id: 107
    //         }
    //       ],
    //       two_step_auth_id: "disabled",
    //       edit_phone_number: false,
    //       azure_AD_signin: false
    //     },
    //     {
    //       saas_user_id: 7,
    //       profile_pic: "https://example.com/profile7.jpg",
    //       full_name: "Amit Singh",
    //       email_address: "amit.singh@hcgel.com",
    //       email_change_to: null,
    //       phone_number: "+91 9912345678",
    //       country: "India",
    //       employee_number: 556677,
    //       department_id: "D007",
    //       department_name: "Research & Development - Scientist",
    //       collaborator_role_id: "R007",
    //       roleName: "Partial access",
    //       access: "partial",
    //       invitation_status: "Pending",
    //       associatedCDMOOrgIDs: "4",
    //       associated_cdmo_list: [
    //         {
    //           cdmo_name: "CDMO UK",
    //           cdmo_id: 108
    //         }
    //       ],
    //       two_step_auth_id: "disabled",
    //       edit_phone_number: false,
    //       azure_AD_signin: false
    //     },
    //     {
    //       saas_user_id: 8,
    //       profile_pic: "https://example.com/profile8.jpg",
    //       full_name: "Neha Kapoor",
    //       email_address: "neha.kapoor@hcgel.com",
    //       email_change_to: null,
    //       phone_number: "+91 9834567890",
    //       country: "India",
    //       employee_number: 667788,
    //       department_id: "D008",
    //       department_name: "Clinical Trials - Coordinator",
    //       collaborator_role_id: "R008",
    //       roleName: "Full access",
    //       access: "full",
    //       invitation_status: "Pending",
    //       associatedCDMOOrgIDs: "5",
    //       associated_cdmo_list: [
    //         {
    //           cdmo_name: "CDMO Canada",
    //           cdmo_id: 109
    //         }
    //       ],
    //       two_step_auth_id: "enabled",
    //       edit_phone_number: true,
    //       azure_AD_signin: true
    //     },
    //     {
    //       saas_user_id: 9,
    //       profile_pic: "https://example.com/profile9.jpg",
    //       full_name: "Rajesh Nair",
    //       email_address: "rajesh.nair@hcgel.com",
    //       email_change_to: null,
    //       phone_number: "+91 9876543210",
    //       country: "India",
    //       employee_number: 778899,
    //       department_id: "D009",
    //       department_name: "Finance - Accountant",
    //       collaborator_role_id: "R009",
    //       roleName: "Partial access",
    //       access: "partial",
    //       invitation_status: "Pending",
    //       associatedCDMOOrgIDs: "6",
    //       associated_cdmo_list: [
    //         {
    //           cdmo_name: "CDMO Singapore",
    //           cdmo_id: 110
    //         }
    //       ],
    //       two_step_auth_id: "disabled",
    //       edit_phone_number: false,
    //       azure_AD_signin: false
    //     }
    //   ],
    //   numberOfPages: 2,
    //   totalNoOfRecords: 9
    // };

  //   const teamMembersList = {
  //     status: true,
  //     data: [
  //         {
  //             saas_user_id: 1,
  //             profile_pic: "https://example.com/profile1.jpg",
  //             full_name: "Tanvi Shukla",
  //             email_address: "tanvi.shukla@hcgel.com",
  //             email_change_to: null,
  //             phone_number: "+91 9475948494",
  //             country: "India",
  //             employee_number: 419556,
  //             department_id: "D001",
  //             department_name: "External Manufacturing - Service Manager",
  //             collaborator_role_id: "R001",
  //             roleName: "Full access",
  //             access: "full",
  //             invitation_status: "Accepted",
  //             associatedCDMOOrgIDs: "all",
  //             associated_cdmo_list: [
  //                 {
  //                     cdmo_name: "CDMO India",
  //                     cdmo_id: 101
  //                 }
  //             ],
  //             two_step_auth_id: "enabled",
  //             edit_phone_number: true,
  //             azure_AD_signin: true
  //         },
  //         {
  //             saas_user_id: 2,
  //             profile_pic: "https://example.com/profile2.jpg",
  //             full_name: "Santhi Cherukuri",
  //             email_address: "santhi.cherukuri@hcgel.com",
  //             email_change_to: null,
  //             phone_number: "+91 9574985055",
  //             country: "India",
  //             employee_number: 339293,
  //             department_id: "D002",
  //             department_name: "Quality Assurance - Head",
  //             collaborator_role_id: "R002",
  //             roleName: "Partial access",
  //             access: "partial",
  //             invitation_status: "Pending",
  //             associatedCDMOOrgIDs: "2,3",
  //             associated_cdmo_list: [
  //                 {
  //                     cdmo_name: "CDMO Global",
  //                     cdmo_id: 102
  //                 },
  //                 {
  //                     cdmo_name: "CDMO Europe",
  //                     cdmo_id: 103
  //                 }
  //             ],
  //             two_step_auth_id: "disabled",
  //             edit_phone_number: false,
  //             azure_AD_signin: false
  //         },
  //         {
  //             saas_user_id: 3,
  //             profile_pic: "https://example.com/profile3.jpg",
  //             full_name: "Rohit Verma",
  //             email_address: "rohit.verma@hcgel.com",
  //             email_change_to: null,
  //             phone_number: "+91 9845093845",
  //             country: "India",
  //             employee_number: 528476,
  //             department_id: "D003",
  //             department_name: "Manufacturing - Supervisor",
  //             collaborator_role_id: "R003",
  //             roleName: "Full access",
  //             access: "full",
  //             invitation_status: "Accepted",
  //             associatedCDMOOrgIDs: "all",
  //             associated_cdmo_list: [
  //                 {
  //                     cdmo_name: "CDMO Asia",
  //                     cdmo_id: 104
  //                 }
  //             ],
  //             two_step_auth_id: "enabled",
  //             edit_phone_number: true,
  //             azure_AD_signin: true
  //         },
  //         {
  //             saas_user_id: 4,
  //             profile_pic: "https://example.com/profile4.jpg",
  //             full_name: "Meera Iyer",
  //             email_address: "meera.iyer@hcgel.com",
  //             email_change_to: null,
  //             phone_number: "+91 8765092834",
  //             country: "India",
  //             employee_number: 678901,
  //             department_id: "D004",
  //             department_name: "Regulatory Affairs - Analyst",
  //             collaborator_role_id: "R004",
  //             roleName: "Partial access",
  //             access: "partial",
  //             invitation_status: "Rejected",
  //             associatedCDMOOrgIDs: "2",
  //             associated_cdmo_list: [
  //                 {
  //                     cdmo_name: "CDMO US",
  //                     cdmo_id: 105
  //                 }
  //             ],
  //             two_step_auth_id: "disabled",
  //             edit_phone_number: false,
  //             azure_AD_signin: false
  //         },
  //         {
  //             saas_user_id: 5,
  //             profile_pic: "https://example.com/profile5.jpg",
  //             full_name: "Anil Kumar",
  //             email_address: "anil.kumar@hcgel.com",
  //             email_change_to: null,
  //             phone_number: "+91 9902837465",
  //             country: "India",
  //             employee_number: 112233,
  //             department_id: "D005",
  //             department_name: "Logistics - Coordinator",
  //             collaborator_role_id: "R005",
  //             roleName: "Full access",
  //             access: "full",
  //             invitation_status: "Accepted",
  //             associatedCDMOOrgIDs: "3",
  //             associated_cdmo_list: [
  //                 {
  //                     cdmo_name: "CDMO Australia",
  //                     cdmo_id: 106
  //                 }
  //             ],
  //             two_step_auth_id: "enabled",
  //             edit_phone_number: true,
  //             azure_AD_signin: true
  //         },
  //         {
  //             saas_user_id: 6,
  //             profile_pic: "https://example.com/profile6.jpg",
  //             full_name: "Priya Menon",
  //             email_address: "priya.menon@hcgel.com",
  //             email_change_to: null,
  //             phone_number: "+91 7894561230",
  //             country: "India",
  //             employee_number: 445566,
  //             department_id: "D006",
  //             department_name: "Procurement - Manager",
  //             collaborator_role_id: "R006",
  //             roleName: "Partial access",
  //             access: "partial",
  //             invitation_status: "Pending",
  //             associatedCDMOOrgIDs: "all",
  //             associated_cdmo_list: [
  //                 {
  //                     cdmo_name: "CDMO Germany",
  //                     cdmo_id: 107
  //                 }
  //             ],
  //             two_step_auth_id: "disabled",
  //             edit_phone_number: false,
  //             azure_AD_signin: false
  //         }
  //     ],
  //     numberOfPages: 2,
  //     totalNoOfRecords: 6
  // };
  
    // dispatch({
    //     type: FETCH_TEAM_ASSOCIATES,
    //     payload:teamMembersList,
    //   });

    //   dispatch({
    //     type: FETCH_TEAM_ASSOCIATES_LOADING,
    //     payload:false,
    //   });
  
    
    axios
      // .post(`${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchTeamMembers`,data)  
      .post(`${appUrl}/user/fetchTeamMembers`,data)
      .then((res) => {
        dispatch({
          type: FETCH_TEAM_ASSOCIATES_LOADING,
          payload: false,
        });
          dispatch({
            type: FETCH_TEAM_ASSOCIATES,
            payload: res.data,
          });
        }) 
      .catch((err) => {
        console.error('API Error:', err);  // Log the error for debugging
  
        // Handle errors
        if (err?.response?.status === 404) {
          dispatch({
            type: FETCH_TEAM_ASSOCIATES_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_TEAM_ASSOCIATES,
            payload:err.response.data,
          });
        } else {
          dispatch({
            type: FETCH_TEAM_ASSOCIATES_LOADING,
            payload: false,
          });
          dispatch({
            type: FETCH_TEAM_ASSOCIATES,
            payload: {
              status: false,
              errorDescription: 'Something went wrong. Please contact support.',
            },
          });
        }
      });
  };
  
  export const deleteInvite = (data) => (dispatch) => {
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: `Please don't refresh or close the tab while processing`,
    });
    axios
      // .get(`${smlUrl}/user/fetchDepartmentDetails`)
      .post(
        `${appUrl}/user/deleteInvite`,
         data
       )
      .then((res) => {
        if (res.data.status) {
        dispatch({
          type: DELETE_INVITE,
          payload: res.data,
        });
        dispatch({
          type: DESTROY_BACKDROP,
        });
      }
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          dispatch({
            type: DELETE_INVITE,
            payload: err.response.data,
          });
        } else {
          dispatch({
            type: DELETE_INVITE,
            payload: {
              status: false,
              errorDescription:
                'Something went wrong. Please contact Schrocken Support.',
            },
          });
        }
        dispatch({
          type: DESTROY_BACKDROP,
        });
      });
  };

